import script from "./AddProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProcess.vue?vue&type=script&setup=true&lang=js"

import "./AddProcess.vue?vue&type=style&index=0&id=79be569b&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79be569b"]])

export default __exports__